/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the Tocsoft.GraphQLCodeGen toolchain https://github.com/tocsoft/GraphQLCodeGen
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import {HttpClient} from 'aurelia-fetch-client';
import {inject} from 'aurelia-framework';
import { apiUrl } from '../../constants'

interface fetchClient {
    fetch(url: RequestInfo, init: RequestInit): Promise<Response>
}

class GraphQLResponse
{
    data: any
    errors: Array<{ message: string }>
}

function RetrieveApplicationError(message:string, httpResponse:Response, graphqlResponse?: GraphQLResponse) {
    this.name = 'RetrieveApplicationError';
    this.message = message || 'Error fetching graphql response';
    this.stack = (new Error()).stack;
    this.httpResponse = httpResponse;
    if(graphqlResponse && graphqlResponse.errors){
        this.errors = graphqlResponse.errors.map(x=>x.message);
    }
  }
  RetrieveApplicationError.prototype = Object.create(Error.prototype);
  RetrieveApplicationError.prototype.constructor = RetrieveApplicationError;
  
export { RetrieveApplicationError }

@inject(HttpClient, apiUrl)
export class RetrieveApplicationClient {

    constructor(public client: fetchClient, public url: string) { }
	
	retrieveApplication_retrieve(	req? :ClaimApplicationRequestInput) : Promise<RetrieveApplicationRetrieveResult>{
        return this.client.fetch(this.url, {
            method : 'POST',
            body : JSON.stringify({
                query : `query retrieve($req: ClaimApplicationRequestInput) {
  claimApplication(request: $req) {
    isLocked
    claimApplication {
      id
      isDuplicate
      ownerId
      status
      screeningInformationViewed
      reporter {
        contact {
          id
          email
          contactType
          title
          firstname
          surname
          companyName
          telephoneCountryCode
          telephone
          isLeadClaimant
          relationshipToLeadClaimant
          relationshipToLeadClaimantFamilyMember
          correspondenceMethod
          address {
            address1
            address2
            address3
            town
            postcode
            country
          }
        }
        isRepresenting
        securityQuestion
        securityAnswer
      }
      claimant {
        contact {
          id
          contactType
          title
          firstname
          surname
          companyName
          telephoneCountryCode
          telephone
          email
          correspondenceMethod
          address {
            address1
            address2
            address3
            town
            postcode
            country
          }
        }
        appointRepresentative
        representative {
          id
          contactType
          title
          firstname
          surname
          companyName
          telephoneCountryCode
          telephone
          email
          correspondenceMethod
          relationshipToLeadClaimant
          relationshipToLeadClaimantFamilyMember
        }
        anyAdditionalClaimants
        additionalClaimants {
          id
          contactType
          title
          firstname
          surname
          companyName
          telephoneCountryCode
          telephone
          email
          correspondenceMethod
          relationshipToLeadClaimant
          relationshipToLeadClaimantFamilyMember
        }
      }
      property {
        address {
          address1
          address2
          address3
          town
          postcode
          country
        }
        policyKnown
        policyNumber
        propertyType
        residentialPropertyType
        commercialPropertyType
        ownershipType
        freeholder {
          id
          contactType
          companyName
          title
          firstname
          surname
          telephoneCountryCode
          telephone
          email
          correspondenceMethod
          address {
            address1
            address2
            address3
            town
            postcode
            country
          }
        }
        newBuildOrConversion
        hasAgent
        agent {
          contactType
          companyName
          title
          firstname
          surname
          telephoneCountryCode
          telephone
          email
          correspondenceMethod
          address {
            address1
            address2
            address3
            town
            postcode
            country
          }
        }
        purchased
        agreementDate
        purchaseDate
        purchasePrice
        reduced
        reductionAmount
        reasonReduced
        retention
        retentionAmount
        retentionReason
        surveyCompleted
        noSurveyReason
        buildingWork
        buildingWorkDetails
        previousClaim
        previousClaimDetails
        otherInsurance
        otherInsuranceDetails
        usage
        selfBuild
        selfBuildStartDate
        overseeingBuilderEmployed
        overseeingBuilder {
          contactType
          companyName
          title
          firstname
          surname
          telephoneCountryCode
          telephone
          email
          correspondenceMethod
          address {
            address1
            address2
            address3
            town
            postcode
            country
          }
        }
        overseeingBuilderStartDate
        contractorDetails
        anyContractualRemedy
        contractualRemedyDetails
      }
      issues {
        id
        area
        details
        dateEvident
        builderNotified
        builderNotifiedDate
        builderNotifiedEvidence
        reportCarriedOut
        reportDetails
        waterIngress
        waterIngressDetails
        fireSafetyRisk
        fireSafetyRiskList
        evidence {
          id
          evidenceType
          description
          documentType
          documents {
            id
            fileId
            fileName
            fileType
            fileSize
          }
        }
      }
      evidence {
        id
        evidenceType
        description
        requiresApproval
        approved
        approvalAdminNotes
        approvalDecisionBy
        approvalDecisionById
        approvalDecisionDate
        documentType
        documents {
          id
          fileId
          fileName
          fileType
          fileSize
        }
        contactId
      }
      declaration {
        additionalInfo
        declarationConfirmation
        statementOfTruthConfirmation
      }
    }
  }
}
`,
                variables : {
					req : req ,
                }
            })
        }).then(response=>{
            if(response.status != 200){
                // error result
                throw new RetrieveApplicationError("http error running 'retrieveApplication_retrieve', see httpResponse for more details.", response)
            }else{
                return response.json().then((json:GraphQLResponse)=>{
                    
                    if(json.errors && json.errors.length > 0){
                        throw new RetrieveApplicationError("graphql error(s) running 'retrieveApplication_retrieve', see errors collection fro more details", response, json)
                    }

                    const result: any = RetrieveApplicationRetrieveResult.fromJS(json.data);                
                    
                    return result;
                })
            }
        })
    }	
}

export class ClaimApplicationRequestInput {
		id? :string;
		ownerId? :string;

    static fromJS(json:any):ClaimApplicationRequestInput{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new ClaimApplicationRequestInput();

	result.id = json["id"];
	result.ownerId = json["ownerId"];

        return result;
    }
}

export class RetrieveApplicationRetrieveResult {
		claimApplication? :ClaimApplicationQueryResult;

    static fromJS(json:any):RetrieveApplicationRetrieveResult{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new RetrieveApplicationRetrieveResult();

result.claimApplication= ClaimApplicationQueryResult.fromJS(json["claimApplication"]);

        return result;
    }
}

export class ClaimApplicationQueryResult {
		isLocked :boolean;
		claimApplication? :ClaimApplicationDtoResult;

    static fromJS(json:any):ClaimApplicationQueryResult{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new ClaimApplicationQueryResult();

	result.isLocked = json["isLocked"];
result.claimApplication= ClaimApplicationDtoResult.fromJS(json["claimApplication"]);

        return result;
    }
}

export class ClaimApplicationDtoResult {
		id? :string;
		isDuplicate? :boolean;
		ownerId? :string;
		status? :ClaimStatus;
		screeningInformationViewed :PolicyType;
		reporter? :ReporterDtoResult;
		claimant? :ClaimantDtoResult;
		property? :PropertyDtoResult;
		issues? :Array<IssueDtoResult>;
		evidence? :Array<EvidenceDto1Result>;
		declaration? :DeclarationDtoResult;

    static fromJS(json:any):ClaimApplicationDtoResult{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new ClaimApplicationDtoResult();

	result.id = json["id"];
	result.isDuplicate = json["isDuplicate"];
	result.ownerId = json["ownerId"];
result.status= ClaimStatus[<string>json["status"]];
result.screeningInformationViewed= PolicyType[<string>json["screeningInformationViewed"]];
result.reporter= ReporterDtoResult.fromJS(json["reporter"]);
result.claimant= ClaimantDtoResult.fromJS(json["claimant"]);
result.property= PropertyDtoResult.fromJS(json["property"]);
if(json["issues"]){ 
		result.issues = json["issues"].map(v=>IssueDtoResult.fromJS(v) );	
	}
if(json["evidence"]){ 
		result.evidence = json["evidence"].map(v=>EvidenceDto1Result.fromJS(v) );	
	}
result.declaration= DeclarationDtoResult.fromJS(json["declaration"]);

        return result;
    }
}

export class ReporterDtoResult {
		contact? :ContactDtoResult;
		isRepresenting? :boolean;
		securityQuestion? :string;
		securityAnswer? :string;

    static fromJS(json:any):ReporterDtoResult{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new ReporterDtoResult();

result.contact= ContactDtoResult.fromJS(json["contact"]);
	result.isRepresenting = json["isRepresenting"];
	result.securityQuestion = json["securityQuestion"];
	result.securityAnswer = json["securityAnswer"];

        return result;
    }
}

export class ContactDtoResult {
		id? :string;
		email? :string;
		contactType? :string;
		title? :string;
		firstname? :string;
		surname? :string;
		companyName? :string;
		telephoneCountryCode? :CountryCodeType;
		telephone? :string;
		isLeadClaimant? :boolean;
		relationshipToLeadClaimant? :string;
		relationshipToLeadClaimantFamilyMember? :string;
		correspondenceMethod? :string;
		address? :AddressDtoResult;

    static fromJS(json:any):ContactDtoResult{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new ContactDtoResult();

	result.id = json["id"];
	result.email = json["email"];
	result.contactType = json["contactType"];
	result.title = json["title"];
	result.firstname = json["firstname"];
	result.surname = json["surname"];
	result.companyName = json["companyName"];
result.telephoneCountryCode= CountryCodeType[<string>json["telephoneCountryCode"]];
	result.telephone = json["telephone"];
	result.isLeadClaimant = json["isLeadClaimant"];
	result.relationshipToLeadClaimant = json["relationshipToLeadClaimant"];
	result.relationshipToLeadClaimantFamilyMember = json["relationshipToLeadClaimantFamilyMember"];
	result.correspondenceMethod = json["correspondenceMethod"];
result.address= AddressDtoResult.fromJS(json["address"]);

        return result;
    }
}

export class AddressDtoResult {
		address1? :string;
		address2? :string;
		address3? :string;
		town? :string;
		postcode? :string;
		country? :CountryCodeType;

    static fromJS(json:any):AddressDtoResult{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new AddressDtoResult();

	result.address1 = json["address1"];
	result.address2 = json["address2"];
	result.address3 = json["address3"];
	result.town = json["town"];
	result.postcode = json["postcode"];
result.country= CountryCodeType[<string>json["country"]];

        return result;
    }
}

export class ClaimantDtoResult {
		contact? :ContactDto1Result;
		appointRepresentative? :boolean;
		representative? :ContactDto2Result;
		anyAdditionalClaimants? :boolean;
		additionalClaimants? :Array<ContactDto2Result>;

    static fromJS(json:any):ClaimantDtoResult{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new ClaimantDtoResult();

result.contact= ContactDto1Result.fromJS(json["contact"]);
	result.appointRepresentative = json["appointRepresentative"];
result.representative= ContactDto2Result.fromJS(json["representative"]);
	result.anyAdditionalClaimants = json["anyAdditionalClaimants"];
if(json["additionalClaimants"]){ 
		result.additionalClaimants = json["additionalClaimants"].map(v=>ContactDto2Result.fromJS(v) );	
	}

        return result;
    }
}

export class ContactDto1Result {
		id? :string;
		contactType? :string;
		title? :string;
		firstname? :string;
		surname? :string;
		companyName? :string;
		telephoneCountryCode? :CountryCodeType;
		telephone? :string;
		email? :string;
		correspondenceMethod? :string;
		address? :AddressDtoResult;

    static fromJS(json:any):ContactDto1Result{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new ContactDto1Result();

	result.id = json["id"];
	result.contactType = json["contactType"];
	result.title = json["title"];
	result.firstname = json["firstname"];
	result.surname = json["surname"];
	result.companyName = json["companyName"];
result.telephoneCountryCode= CountryCodeType[<string>json["telephoneCountryCode"]];
	result.telephone = json["telephone"];
	result.email = json["email"];
	result.correspondenceMethod = json["correspondenceMethod"];
result.address= AddressDtoResult.fromJS(json["address"]);

        return result;
    }
}

export class ContactDto2Result {
		id? :string;
		contactType? :string;
		title? :string;
		firstname? :string;
		surname? :string;
		companyName? :string;
		telephoneCountryCode? :CountryCodeType;
		telephone? :string;
		email? :string;
		correspondenceMethod? :string;
		relationshipToLeadClaimant? :string;
		relationshipToLeadClaimantFamilyMember? :string;

    static fromJS(json:any):ContactDto2Result{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new ContactDto2Result();

	result.id = json["id"];
	result.contactType = json["contactType"];
	result.title = json["title"];
	result.firstname = json["firstname"];
	result.surname = json["surname"];
	result.companyName = json["companyName"];
result.telephoneCountryCode= CountryCodeType[<string>json["telephoneCountryCode"]];
	result.telephone = json["telephone"];
	result.email = json["email"];
	result.correspondenceMethod = json["correspondenceMethod"];
	result.relationshipToLeadClaimant = json["relationshipToLeadClaimant"];
	result.relationshipToLeadClaimantFamilyMember = json["relationshipToLeadClaimantFamilyMember"];

        return result;
    }
}

export class PropertyDtoResult {
		address? :AddressDtoResult;
		policyKnown? :boolean;
		policyNumber? :string;
		propertyType? :string;
		residentialPropertyType? :string;
		commercialPropertyType? :string;
		ownershipType? :string;
		freeholder? :ContactDto3Result;
		newBuildOrConversion? :string;
		hasAgent? :boolean;
		agent? :ContactDto4Result;
		purchased? :boolean;
		agreementDate? :Date;
		purchaseDate? :Date;
		purchasePrice? :string;
		reduced? :boolean;
		reductionAmount? :string;
		reasonReduced? :string;
		retention? :boolean;
		retentionAmount? :string;
		retentionReason? :string;
		surveyCompleted? :boolean;
		noSurveyReason? :string;
		buildingWork? :boolean;
		buildingWorkDetails? :string;
		previousClaim? :boolean;
		previousClaimDetails? :string;
		otherInsurance? :boolean;
		otherInsuranceDetails? :string;
		usage? :string;
		selfBuild? :boolean;
		selfBuildStartDate? :Date;
		overseeingBuilderEmployed? :boolean;
		overseeingBuilder? :ContactDto4Result;
		overseeingBuilderStartDate? :Date;
		contractorDetails? :string;
		anyContractualRemedy? :boolean;
		contractualRemedyDetails? :string;

    static fromJS(json:any):PropertyDtoResult{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new PropertyDtoResult();

result.address= AddressDtoResult.fromJS(json["address"]);
	result.policyKnown = json["policyKnown"];
	result.policyNumber = json["policyNumber"];
	result.propertyType = json["propertyType"];
	result.residentialPropertyType = json["residentialPropertyType"];
	result.commercialPropertyType = json["commercialPropertyType"];
	result.ownershipType = json["ownershipType"];
result.freeholder= ContactDto3Result.fromJS(json["freeholder"]);
	result.newBuildOrConversion = json["newBuildOrConversion"];
	result.hasAgent = json["hasAgent"];
result.agent= ContactDto4Result.fromJS(json["agent"]);
	result.purchased = json["purchased"];
result.agreementDate = json["agreementDate"] ? new Date(json["agreementDate"]) : null;
result.purchaseDate = json["purchaseDate"] ? new Date(json["purchaseDate"]) : null;
	result.purchasePrice = json["purchasePrice"];
	result.reduced = json["reduced"];
	result.reductionAmount = json["reductionAmount"];
	result.reasonReduced = json["reasonReduced"];
	result.retention = json["retention"];
	result.retentionAmount = json["retentionAmount"];
	result.retentionReason = json["retentionReason"];
	result.surveyCompleted = json["surveyCompleted"];
	result.noSurveyReason = json["noSurveyReason"];
	result.buildingWork = json["buildingWork"];
	result.buildingWorkDetails = json["buildingWorkDetails"];
	result.previousClaim = json["previousClaim"];
	result.previousClaimDetails = json["previousClaimDetails"];
	result.otherInsurance = json["otherInsurance"];
	result.otherInsuranceDetails = json["otherInsuranceDetails"];
	result.usage = json["usage"];
	result.selfBuild = json["selfBuild"];
result.selfBuildStartDate = json["selfBuildStartDate"] ? new Date(json["selfBuildStartDate"]) : null;
	result.overseeingBuilderEmployed = json["overseeingBuilderEmployed"];
result.overseeingBuilder= ContactDto4Result.fromJS(json["overseeingBuilder"]);
result.overseeingBuilderStartDate = json["overseeingBuilderStartDate"] ? new Date(json["overseeingBuilderStartDate"]) : null;
	result.contractorDetails = json["contractorDetails"];
	result.anyContractualRemedy = json["anyContractualRemedy"];
	result.contractualRemedyDetails = json["contractualRemedyDetails"];

        return result;
    }
}

export class ContactDto3Result {
		id? :string;
		contactType? :string;
		companyName? :string;
		title? :string;
		firstname? :string;
		surname? :string;
		telephoneCountryCode? :CountryCodeType;
		telephone? :string;
		email? :string;
		correspondenceMethod? :string;
		address? :AddressDtoResult;

    static fromJS(json:any):ContactDto3Result{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new ContactDto3Result();

	result.id = json["id"];
	result.contactType = json["contactType"];
	result.companyName = json["companyName"];
	result.title = json["title"];
	result.firstname = json["firstname"];
	result.surname = json["surname"];
result.telephoneCountryCode= CountryCodeType[<string>json["telephoneCountryCode"]];
	result.telephone = json["telephone"];
	result.email = json["email"];
	result.correspondenceMethod = json["correspondenceMethod"];
result.address= AddressDtoResult.fromJS(json["address"]);

        return result;
    }
}

export class ContactDto4Result {
		contactType? :string;
		companyName? :string;
		title? :string;
		firstname? :string;
		surname? :string;
		telephoneCountryCode? :CountryCodeType;
		telephone? :string;
		email? :string;
		correspondenceMethod? :string;
		address? :AddressDtoResult;

    static fromJS(json:any):ContactDto4Result{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new ContactDto4Result();

	result.contactType = json["contactType"];
	result.companyName = json["companyName"];
	result.title = json["title"];
	result.firstname = json["firstname"];
	result.surname = json["surname"];
result.telephoneCountryCode= CountryCodeType[<string>json["telephoneCountryCode"]];
	result.telephone = json["telephone"];
	result.email = json["email"];
	result.correspondenceMethod = json["correspondenceMethod"];
result.address= AddressDtoResult.fromJS(json["address"]);

        return result;
    }
}

export class IssueDtoResult {
		id? :string;
		area? :string;
		details? :string;
		dateEvident? :Date;
		builderNotified? :boolean;
		builderNotifiedDate? :Date;
		builderNotifiedEvidence? :boolean;
		reportCarriedOut? :boolean;
		reportDetails? :string;
		waterIngress? :boolean;
		waterIngressDetails? :string;
		fireSafetyRisk? :boolean;
		fireSafetyRiskList? :Array<string>;
		evidence? :Array<EvidenceDtoResult>;

    static fromJS(json:any):IssueDtoResult{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new IssueDtoResult();

	result.id = json["id"];
	result.area = json["area"];
	result.details = json["details"];
result.dateEvident = json["dateEvident"] ? new Date(json["dateEvident"]) : null;
	result.builderNotified = json["builderNotified"];
result.builderNotifiedDate = json["builderNotifiedDate"] ? new Date(json["builderNotifiedDate"]) : null;
	result.builderNotifiedEvidence = json["builderNotifiedEvidence"];
	result.reportCarriedOut = json["reportCarriedOut"];
	result.reportDetails = json["reportDetails"];
	result.waterIngress = json["waterIngress"];
	result.waterIngressDetails = json["waterIngressDetails"];
	result.fireSafetyRisk = json["fireSafetyRisk"];
	result.fireSafetyRiskList = json["fireSafetyRiskList"];
if(json["evidence"]){ 
		result.evidence = json["evidence"].map(v=>EvidenceDtoResult.fromJS(v) );	
	}

        return result;
    }
}

export class EvidenceDtoResult {
		id? :string;
		evidenceType? :string;
		description? :string;
		documentType? :string;
		documents? :Array<DocumentDtoResult>;

    static fromJS(json:any):EvidenceDtoResult{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new EvidenceDtoResult();

	result.id = json["id"];
	result.evidenceType = json["evidenceType"];
	result.description = json["description"];
	result.documentType = json["documentType"];
if(json["documents"]){ 
		result.documents = json["documents"].map(v=>DocumentDtoResult.fromJS(v) );	
	}

        return result;
    }
}

export class DocumentDtoResult {
		id? :string;
		fileId :string;
		fileName? :string;
		fileType? :string;
		fileSize :number;

    static fromJS(json:any):DocumentDtoResult{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new DocumentDtoResult();

	result.id = json["id"];
	result.fileId = json["fileId"];
	result.fileName = json["fileName"];
	result.fileType = json["fileType"];
	result.fileSize = json["fileSize"];

        return result;
    }
}

export class EvidenceDto1Result {
		id? :string;
		evidenceType? :string;
		description? :string;
		requiresApproval? :boolean;
		approved? :boolean;
		approvalAdminNotes? :string;
		approvalDecisionBy? :string;
		approvalDecisionById? :string;
		approvalDecisionDate? :string;
		documentType? :string;
		documents? :Array<DocumentDtoResult>;
		contactId? :string;

    static fromJS(json:any):EvidenceDto1Result{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new EvidenceDto1Result();

	result.id = json["id"];
	result.evidenceType = json["evidenceType"];
	result.description = json["description"];
	result.requiresApproval = json["requiresApproval"];
	result.approved = json["approved"];
	result.approvalAdminNotes = json["approvalAdminNotes"];
	result.approvalDecisionBy = json["approvalDecisionBy"];
	result.approvalDecisionById = json["approvalDecisionById"];
	result.approvalDecisionDate = json["approvalDecisionDate"];
	result.documentType = json["documentType"];
if(json["documents"]){ 
		result.documents = json["documents"].map(v=>DocumentDtoResult.fromJS(v) );	
	}
	result.contactId = json["contactId"];

        return result;
    }
}

export class DeclarationDtoResult {
		additionalInfo? :string;
		declarationConfirmation? :boolean;
		statementOfTruthConfirmation? :boolean;

    static fromJS(json:any):DeclarationDtoResult{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new DeclarationDtoResult();

	result.additionalInfo = json["additionalInfo"];
	result.declarationConfirmation = json["declarationConfirmation"];
	result.statementOfTruthConfirmation = json["statementOfTruthConfirmation"];

        return result;
    }
}


	export enum ClaimStatus
	{
		INCOMPLETE = "INCOMPLETE",
		SUBMITTED = "SUBMITTED",
		REVIEWED = "REVIEWED",
		ARCHIVED = "ARCHIVED",
	}

	export enum PolicyType
	{
		UNKNOWN = "UNKNOWN",
		NEWHOMES = "NEWHOMES",
		SOCIALHOUSING = "SOCIALHOUSING",
		PRS = "PRS",
		COMMERCIAL = "COMMERCIAL",
		SELFBUILD = "SELFBUILD",
		COMPLETED = "COMPLETED",
		INSOLVENCY = "INSOLVENCY",
		ASUCDIG = "ASUCDIG",
		ASUCBIG = "ASUCBIG",
		ROADSEWERBONDS = "ROADSEWERBONDS",
	}

	export enum CountryCodeType
	{
		NONE = "NONE",
		AFGHANISTAN = "AFGHANISTAN",
		ALBANIA = "ALBANIA",
		ALGERIA = "ALGERIA",
		AMERICANSAMOA = "AMERICANSAMOA",
		ANDORRA = "ANDORRA",
		ANGOLA = "ANGOLA",
		ANGUILLA = "ANGUILLA",
		ANTARCTICA = "ANTARCTICA",
		ARGENTINA = "ARGENTINA",
		ARMENIA = "ARMENIA",
		ARUBA = "ARUBA",
		AUSTRALIA = "AUSTRALIA",
		AUSTRIA = "AUSTRIA",
		AZERBAIJAN = "AZERBAIJAN",
		BAHAMAS = "BAHAMAS",
		BAHRAIN = "BAHRAIN",
		BANGLADESH = "BANGLADESH",
		BARBADOS = "BARBADOS",
		BELARUS = "BELARUS",
		BELGIUM = "BELGIUM",
		BELIZE = "BELIZE",
		BENIN = "BENIN",
		BERMUDA = "BERMUDA",
		BHUTAN = "BHUTAN",
		BOLIVIA = "BOLIVIA",
		BOSNIAANDHERZEGOVINA = "BOSNIAANDHERZEGOVINA",
		BOTSWANA = "BOTSWANA",
		BRAZIL = "BRAZIL",
		BRITISHVIRGINISLANDS = "BRITISHVIRGINISLANDS",
		BRUNEI = "BRUNEI",
		BULGARIA = "BULGARIA",
		BURKINAFASO = "BURKINAFASO",
		BURUNDI = "BURUNDI",
		CAMBODIA = "CAMBODIA",
		CAMEROON = "CAMEROON",
		CANADA = "CANADA",
		CAPEVERDE = "CAPEVERDE",
		CAYMANISLANDS = "CAYMANISLANDS",
		CENTRALAFRICANREPUBLIC = "CENTRALAFRICANREPUBLIC",
		CHILE = "CHILE",
		CHINA = "CHINA",
		COLOMBIA = "COLOMBIA",
		COMOROS = "COMOROS",
		COOKISLANDS = "COOKISLANDS",
		COSTARICA = "COSTARICA",
		CROATIA = "CROATIA",
		CUBA = "CUBA",
		CURACAO = "CURACAO",
		CYPRUS = "CYPRUS",
		CZECHREPUBLIC = "CZECHREPUBLIC",
		DEMOCRATICREPUBLICOFCONGO = "DEMOCRATICREPUBLICOFCONGO",
		DENMARK = "DENMARK",
		DJIBOUTI = "DJIBOUTI",
		DOMINICA = "DOMINICA",
		DOMINICANREPUBLIC = "DOMINICANREPUBLIC",
		EASTTIMOR = "EASTTIMOR",
		ECUADOR = "ECUADOR",
		EGYPT = "EGYPT",
		ELSALVADOR = "ELSALVADOR",
		EQUATORIALGUINEA = "EQUATORIALGUINEA",
		ERITREA = "ERITREA",
		ESTONIA = "ESTONIA",
		ETHIOPIA = "ETHIOPIA",
		FALKLANDISLANDS = "FALKLANDISLANDS",
		FAROEISLANDS = "FAROEISLANDS",
		FIJI = "FIJI",
		FINLAND = "FINLAND",
		FRANCE = "FRANCE",
		FRENCHPOLYNESIA = "FRENCHPOLYNESIA",
		GABON = "GABON",
		GAMBIA = "GAMBIA",
		GEORGIA = "GEORGIA",
		GERMANY = "GERMANY",
		GHANA = "GHANA",
		GIBRALTAR = "GIBRALTAR",
		GREECE = "GREECE",
		GREENLAND = "GREENLAND",
		GUADELOUPE = "GUADELOUPE",
		GUAM = "GUAM",
		GUATEMALA = "GUATEMALA",
		GUINEA = "GUINEA",
		GUINEABISSAU = "GUINEABISSAU",
		GUYANA = "GUYANA",
		HAITI = "HAITI",
		HONDURAS = "HONDURAS",
		HONGKONG = "HONGKONG",
		HUNGARY = "HUNGARY",
		ICELAND = "ICELAND",
		INDIA = "INDIA",
		INDONESIA = "INDONESIA",
		IRAN = "IRAN",
		IRAQ = "IRAQ",
		IRELAND = "IRELAND",
		ISLEOFMAN = "ISLEOFMAN",
		ISRAEL = "ISRAEL",
		ITALY = "ITALY",
		IVORYCOAST = "IVORYCOAST",
		JAMAICA = "JAMAICA",
		JAPAN = "JAPAN",
		JORDAN = "JORDAN",
		KAZAKHSTAN = "KAZAKHSTAN",
		KENYA = "KENYA",
		KIRIBATI = "KIRIBATI",
		KOSOVO = "KOSOVO",
		KUWAIT = "KUWAIT",
		KYRGYZSTAN = "KYRGYZSTAN",
		LAOS = "LAOS",
		LATVIA = "LATVIA",
		LEBANON = "LEBANON",
		LESOTHO = "LESOTHO",
		LIBERIA = "LIBERIA",
		LIBYA = "LIBYA",
		LIECHTENSTEIN = "LIECHTENSTEIN",
		LITHUANIA = "LITHUANIA",
		LUXEMBOURG = "LUXEMBOURG",
		MACAU = "MACAU",
		MACEDONIA = "MACEDONIA",
		MADAGASCAR = "MADAGASCAR",
		MALAWI = "MALAWI",
		MALAYSIA = "MALAYSIA",
		MALDIVES = "MALDIVES",
		MALI = "MALI",
		MALTA = "MALTA",
		MARSHALLISLANDS = "MARSHALLISLANDS",
		MAURITANIA = "MAURITANIA",
		MAURITIUS = "MAURITIUS",
		MEXICO = "MEXICO",
		MICRONESIA = "MICRONESIA",
		MOLDOVA = "MOLDOVA",
		MONACO = "MONACO",
		MONGOLIA = "MONGOLIA",
		MONTENEGRO = "MONTENEGRO",
		MONTSERRAT = "MONTSERRAT",
		MOROCCO = "MOROCCO",
		MOZAMBIQUE = "MOZAMBIQUE",
		MYANMARBURMA = "MYANMARBURMA",
		NAMIBIA = "NAMIBIA",
		NAURU = "NAURU",
		NEPAL = "NEPAL",
		NETHERLANDS = "NETHERLANDS",
		NEWCALEDONIA = "NEWCALEDONIA",
		NEWZEALAND = "NEWZEALAND",
		NICARAGUA = "NICARAGUA",
		NIGER = "NIGER",
		NIGERIA = "NIGERIA",
		NIUE = "NIUE",
		NORFOLKISLAND = "NORFOLKISLAND",
		NORTHKOREA = "NORTHKOREA",
		NORTHERNMARIANAISLANDS = "NORTHERNMARIANAISLANDS",
		NORWAY = "NORWAY",
		OMAN = "OMAN",
		PAKISTAN = "PAKISTAN",
		PALAU = "PALAU",
		PANAMA = "PANAMA",
		PAPUANEWGUINEA = "PAPUANEWGUINEA",
		PARAGUAY = "PARAGUAY",
		PERU = "PERU",
		PHILIPPINES = "PHILIPPINES",
		PITCAIRNISLANDS = "PITCAIRNISLANDS",
		POLAND = "POLAND",
		PORTUGAL = "PORTUGAL",
		PUERTORICO = "PUERTORICO",
		QATAR = "QATAR",
		REPUBLICOFTHECONGO = "REPUBLICOFTHECONGO",
		REUNION = "REUNION",
		ROMANIA = "ROMANIA",
		RUSSIA = "RUSSIA",
		RWANDA = "RWANDA",
		SAINTBARTHELEMY = "SAINTBARTHELEMY",
		SAINTHELENA = "SAINTHELENA",
		SAINTKITTSANDNEVIS = "SAINTKITTSANDNEVIS",
		SAINTLUCIA = "SAINTLUCIA",
		SAINTMARTIN = "SAINTMARTIN",
		SAINTPIERREANDMIQUELON = "SAINTPIERREANDMIQUELON",
		SAINTVINCENTANDTHEGRENADINES = "SAINTVINCENTANDTHEGRENADINES",
		SAMOA = "SAMOA",
		SANMARINO = "SANMARINO",
		SAOTOMEANDPRINCIPE = "SAOTOMEANDPRINCIPE",
		SAUDIARABIA = "SAUDIARABIA",
		SENEGAL = "SENEGAL",
		SERBIA = "SERBIA",
		SEYCHELLES = "SEYCHELLES",
		SIERRALEONE = "SIERRALEONE",
		SINGAPORE = "SINGAPORE",
		SLOVAKIA = "SLOVAKIA",
		SLOVENIA = "SLOVENIA",
		SOLOMONISLANDS = "SOLOMONISLANDS",
		SOMALIA = "SOMALIA",
		SOUTHAFRICA = "SOUTHAFRICA",
		SOUTHKOREA = "SOUTHKOREA",
		SOUTHSUDAN = "SOUTHSUDAN",
		SPAIN = "SPAIN",
		SRILANKA = "SRILANKA",
		SUDAN = "SUDAN",
		SURINAME = "SURINAME",
		SWAZILAND = "SWAZILAND",
		SWEDEN = "SWEDEN",
		SWITZERLAND = "SWITZERLAND",
		SYRIA = "SYRIA",
		TAIWAN = "TAIWAN",
		TAJIKISTAN = "TAJIKISTAN",
		TANZANIA = "TANZANIA",
		THAILAND = "THAILAND",
		TOGO = "TOGO",
		TOKELAU = "TOKELAU",
		TRINIDADANDTOBAGO = "TRINIDADANDTOBAGO",
		TUNISIA = "TUNISIA",
		TURKEY = "TURKEY",
		TURKMENISTAN = "TURKMENISTAN",
		TUVALU = "TUVALU",
		UGANDA = "UGANDA",
		UKRAINE = "UKRAINE",
		UNITEDARABEMIRATES = "UNITEDARABEMIRATES",
		UNITEDKINGDOM = "UNITEDKINGDOM",
		UNITEDSTATES = "UNITEDSTATES",
		URUGUAY = "URUGUAY",
		UZBEKISTAN = "UZBEKISTAN",
		VANUATU = "VANUATU",
		VATICAN = "VATICAN",
		VENEZUELA = "VENEZUELA",
		VIETNAM = "VIETNAM",
		WESTERNSAHARA = "WESTERNSAHARA",
		YEMEN = "YEMEN",
		ZAMBIA = "ZAMBIA",
		ZIMBABWE = "ZIMBABWE",
	}

